export const BoxAllSide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z" />
  </svg>
);
export const BoxTopSide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z"
      style={{
        opacity: 0.25,
      }}
    />
    <path d="m16.5 6h-9v-1.5h9z" />
  </svg>
);

export const BoxRightSide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z"
      style={{
        opacity: 0.25,
      }}
    />
    <path d="m18 16.5v-9h1.5v9z" />
  </svg>
);

export const BoxBottomSide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z"
      style={{
        opacity: 0.25,
      }}
    />
    <path d="m16.5 19.5h-9v-1.5h9z" fill="rgb(30, 30, 30)" />
  </svg>
);

export const BoxLeftSide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z"
      style={{
        opacity: 0.25,
      }}
    />
    <path d="m4.5 16.5v-9h1.5v9z" />
  </svg>
);

export const BoxVerticalSide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z"
      style={{
        opacity: 0.25,
      }}
    />
    <path d="m7.5 6h9v-1.5h-9z"></path>
    <path d="m7.5 19.5h9v-1.5h-9z"></path>
  </svg>
);

export const BoxHorizontalSide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z"
      style={{
        opacity: 0.25,
      }}
    />
    <path></path>
    <path d="m4.5 7.5v9h1.5v-9z"></path>
    <path d="m18 7.5v9h1.5v-9z"></path>
  </svg>
);
